import { render } from "./UploadTag.vue?vue&type=template&id=612f6286&scoped=true"
import script from "./UploadTag.vue?vue&type=script&lang=js"
export * from "./UploadTag.vue?vue&type=script&lang=js"

import "./UploadTag.vue?vue&type=style&index=0&id=612f6286&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-612f6286"]])

export default __exports__